import { useEditModalStore } from '../../model/use-edit-modal.store';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { RegNo } from 'entities/vehicle';
import { WipNo } from 'entities/workshop';
import { useAppStore } from 'features/settings/contexts/settings.context';
import { SkeletonWrapper } from 'shared';

export const ModalHeader = () => {
  const { closeModal, state, isLoading } = useEditModalStore();
  const {
    state: { branches }
  } = useAppStore();

  return (
    <div className="modal-header px-8 pb-0">
      <div className="w-100 d-flex gap-3 align-items-center">
        <div>
          <h2 className="fw-bolder">Edit Warranty Item</h2>
        </div>
        <div className={clsx(styles.mw50px, 'ms-2')}>
          <SkeletonWrapper isShow={isLoading} height={30}>
            <WipNo wipNo={state?.wipNo} />
          </SkeletonWrapper>
        </div>
        <div className={styles.mw50px}>
          <SkeletonWrapper isShow={isLoading} height={30}>
            <RegNo regNo={state?.regNo} />
          </SkeletonWrapper>
        </div>
        <div className={clsx(styles.branchHeader)}>
          <SkeletonWrapper isShow={isLoading} height={30}>
            <div className={styles.mw50px}>
              <InlineSvg path="/media/icons/custom/map.svg" className="svg-icon-3" />
              {branches?.find((x) => x.value == state?.branch)?.label ?? '-'}
            </div>
          </SkeletonWrapper>
        </div>
      </div>

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-maintenance-task-action="close"
        onClick={() => closeModal()}
        style={{ cursor: 'pointer' }}
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
